import FooterPage from "../components/Custom/Footer/FooterPage";
import Navbar from "../components/Custom/Navbar/Navbar";
import General from "../components/Privacy/General/General";
import Participants from "../components/Privacy/Participants/Participants";
import Prospects from "../components/Privacy/Prospects/Prospects";

export default function Privacy() {
  return (
    <>
      <Navbar />
      <General />
      <Prospects />
      <Participants />
      <FooterPage />
    </>
  );
}
